module.exports = __webpack_public_path__ + "static/img/bannerbg01.9b1f21ad.jpg";